import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import * as characters from "./characters";
export var lookUpTldsInTrie = function lookUpTldsInTrie(labels, trie) {
  var labelsToCheck = _sliceInstanceProperty(labels).call(labels);

  var tlds = [];
  var node = trie;

  while (labelsToCheck.length !== 0) {
    var label = labelsToCheck.pop();
    var labelLowerCase = label.toLowerCase();

    if (node.children.has(characters.WILDCARD)) {
      if (node.children.has(characters.EXCEPTION + labelLowerCase)) {
        break;
      }

      node = node.children.get(characters.WILDCARD);
    } else {
      if (node.children.has(labelLowerCase) === false) {
        break;
      }

      node = node.children.get(labelLowerCase);
    }

    tlds.unshift(label);
  }

  return tlds;
};